var apMonths = [
  "Jan.",
  "Feb.",
  "March",
  "April",
  "May",
  "June",
  "July",
  "Aug.",
  "Sept.",
  "Oct.",
  "Nov.",
  "Dec."
];

module.exports = function(timestamp) {
  var dateString = "...";

  if (timestamp) {
    var date = new Date(timestamp);
    // date formatting options: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#parameters
    // dateString = date.toLocaleString('en-US', {
    //   timeZone: 'America/New_York',
    //   timeZoneName: 'shortGeneric',
    //   hour: 'numeric',
    //   minute: 'numeric',
    //   month: 'short',
    //   day: 'numeric'
    // }).replace(', ', ' at ')
    //   .replace('Nov ', 'Nov. ')
    //   .replace('AM', 'a.m.')
    //   .replace('PM', 'p.m.');

    var localized = date.toLocaleString('en-US', {
      timeZone: 'America/New_York',
      timeZoneName: 'shortGeneric'
    }).split(" ");
    var localizedDate = localized[0].split("/");
    var localizedTime = localized[1].split(":");

    var month = apMonths[localizedDate[0] - 1];
    var day = localizedDate[1];

    var hours = localizedTime[0];
    var minutes = localizedTime[1].padStart(2, "0");
    var suffix = localized[2]
      .replace('AM', 'a.m.')
      .replace('PM', 'p.m.');
    var zone = localized[3]

    dateString = `${hours}:${minutes} ${suffix} ${ zone } on ${month} ${day}`;
    // console.log(localized);
    // console.log(dateString);


   /*
    var hours = date.getHours();
    if (!isNaN(hours)) {
      var suffix = hours < 12 ? "a.m." : "p.m.";
      if (!hours) {
        hours = 12;
      } else if (hours > 12) {
        hours -= 12;
      }
      var minutes = date.getMinutes().toString().padStart(2, "0");
      var month = apMonths[date.getMonth()];
      var day = date.getDate();
      var year = date.getFullYear();
      // dateString = `${hours}:${minutes} ${suffix} on ${month} ${day}, ${year}`;
      dateString = `${hours}:${minutes} ${suffix} on ${month} ${day}`;
    }
    */
  }
  return dateString;
};
